import React,{ useState, useEffect,useRef } from 'react'
import { Card } from 'primereact/card';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { deleteTribe, getAllTribes,createTribe,editTribe,getOneTribe } from '../../api/axiosTribes';
import { Toast } from 'primereact/toast';
import { AllToasts } from '../../components/Toasts/AllToasts';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';  
import { useNavigate } from 'react-router-dom';
import { useContext } from 'react';
import DataContext from '../../context/DataContext';
import DeleteDialog from '../../components/dialogs/DeleteDialog';
import { Dialog } from 'primereact/dialog';
import { Skeleton } from 'primereact/skeleton';
import SearchToolBar from '../../components/buttonActions/SearchToolBar';
import TableActions from '../../components/buttonActions/TableActions';








const Tribes = () => {
  const { tribes, setTribes, setFetcherror } = useContext(DataContext);
 
  const toast = useRef(null);
  const [globalFilter, setGlobalFilter] = useState("");
  const navigate = useNavigate()

  const [isLoading, setIsLoading] = useState(true);
  const [addItemeDialogVisible, setAddItemDialogVisible] = useState(false);
  const [editDialogVisible, setEditDialogVisible] = useState(false);
  const [deleteDialogVisible, setDeleteDialogVisible] = useState(false);
  
  const [selectedId, setSelectedId] = useState(); //Track Id for Deleting or Editing
  
  const [tribe, setTribe] = useState("");
  const [editedTribe, setEditedTribe] = useState("");
  


 

  const NewTitle = "All Tribes";
  useEffect(() => {
    
    getAllTribes(setTribes, setFetcherror,setIsLoading);
    
  }, []);


  const filteredTribes = tribes.filter((item) => item.name.toLowerCase().includes(globalFilter.toLowerCase()));
  const filteredReversedTribes = filteredTribes.reverse();
  
  const handleAllToasts = (statusNum, msg) => {
    AllToasts(statusNum, msg, toast);
  };

  // Delete Dialogue
  const deletefunction = (pkid, setTribes, setFetcherror, handleAllToasts) => {
    return () => {
      deleteTribe(pkid, setTribes, setFetcherror, handleAllToasts);
    };
  };
  const deletedialogHeader = "Confirm Delete";
  const deletedialogContents = (
      <p>Do you really want to delete this Tribe?, Click "Yes" to Proceed or "No" to Cancel</p>
  );

  const getItemtoEdit = (pkid, items) => {
    const foundItem = items.find((item) => item.id === pkid);
    setEditedTribe(foundItem?.name);
   
  }
  
  const skeletonitems = Array.from({ length: 5 }, (v, i) => i);

  
  return (

    
    <div className="card">
      <Toast ref={toast} />
      
      <Card title={ NewTitle}>
          <SearchToolBar
              setAddItemDialogVisible={setAddItemDialogVisible}
              globalFilter={globalFilter}
              setGlobalFilter={setGlobalFilter}
              searchPlaceholder="Tribes"
              createLabel="Tribe"
          />
          
        {!isLoading &&
          <DataTable
            value={filteredTribes}
            showGridlines
            paginator
            rows={10}
            rowsPerPageOptions={[5, 10, 20]}
            emptyMessage="No tribes found"
          >
            <Column header="S/N" body={(rowData) => tribes.indexOf(rowData) + 1} sortable> </Column>
            <Column header="Name" body={(rowData) => rowData.name} sortable></Column>
            <Column header="Actions" body={(rowData) => (
                 <TableActions
                  id={rowData.id}
                  data={tribes}
                  getItemtoEdit={getItemtoEdit}
                  setSelectedId={setSelectedId}
                  setEditDialogVisible={setEditDialogVisible}
                  setDeleteDialogVisible={ setDeleteDialogVisible}
               />
                        
               )}>
            </Column>
          </DataTable>
        } 
         
        {isLoading && 
        
        <DataTable value={skeletonitems} className="p-datatable-striped">
        <Column field="S/N" header="S/N" style={{ width: '25%' }} body={<Skeleton />}></Column>
        <Column field="Name" header="Name" style={{ width: '25%' }} body={<Skeleton />}></Column>
        <Column field="Actions" header="Actions" style={{ width: '25%' }} body={<Skeleton />}></Column>
        </DataTable>
        }
      
        
        {addItemeDialogVisible &&
          
          <div className="card flex justify-content-center">
          <Dialog className='-mt-8' header="New Tribe" visible={addItemeDialogVisible} style={{ width: '25vw' }} onHide={() => setAddItemDialogVisible(false)} >
              <form onSubmit={(e) => { 
                e.preventDefault();
                createTribe(tribe, setTribe, setFetcherror, handleAllToasts, setTribes);
                if (tribe) { setAddItemDialogVisible(false); }
              }}>
                  <InputText
                    className='w-full mb-4'
                    type="text"
                    placeholder="Enter Tribe Name"
                    value={tribe}
                    onChange={(e) => setTribe(e.target.value)}
                  />

                  
                 <div  className="card flex justify-content-end">
                  <Button label="Cancel" icon="pi pi-times" onClick={() => { setAddItemDialogVisible(false); setTribe("");  }} className="p-button-text px-3 py-1 text-sm" />
                  <Button type='submit' label="Save" icon="pi pi-check"  autoFocus  className="px-3 py-1 text-sm"/>
                </div>
            </form>
          </Dialog>
         </div>
        
        }
        



        {
          editDialogVisible &&
          <div className="card flex justify-content-center">
          <Dialog className='-mt-8' header="Edit Tribe" visible={editDialogVisible} style={{ width: '25vw' }} onHide={() => setEditDialogVisible(false)} >
              <form onSubmit={(e) => { 
                e.preventDefault();
                editTribe( selectedId, editedTribe, setEditedTribe,  setFetcherror, handleAllToasts, setTribes);
                if (editedTribe) { setEditDialogVisible(false); }
              }}>
                  <InputText
                    className='w-full mb-4'
                    type="text"
                    // disabled
                    placeholder="Enter Tribe Name"
                    value={editedTribe}
                    onChange={(e) => setEditedTribe(e.target.value)}
                  />

                  
                 <div  className="card flex justify-content-end">
                  <Button label="Cancel" icon="pi pi-times" onClick={() => { setEditDialogVisible(false); setTribe("");  }} className="p-button-text px-3 py-1 text-sm" />
                  <Button type='submit' label="Save" icon="pi pi-check"  autoFocus  className="px-3 py-1 text-sm"/>
                </div>
            </form>
          </Dialog>
         </div>
        
        }

        
        
        {
                deleteDialogVisible &&
        
                <DeleteDialog
                    dilogvisible={deleteDialogVisible}
                    setDilogvisibleVisible={setDeleteDialogVisible}
                    deletefucton={deletefunction(selectedId, setTribes, setFetcherror, handleAllToasts)}
                    dialogHeader={deletedialogHeader}
                    dialogContents={ deletedialogContents}
                    
                 />
      } 
       
                
      </Card>
      
    </div>
  )
}

export default Tribes


